import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { BehaviorSubject } from 'rxjs';
import { ViewState } from '../internal/views/view.state';
import { I18n } from './i18n';

const moment = I18n.moment;

@Injectable()
export class TitleService {
  title: BehaviorSubject<string> = new BehaviorSubject('');
  subtitle: BehaviorSubject<string[]> = new BehaviorSubject([]);
  showLocation: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private store: Store) {}

  public setTitle(title: string) {
    this.title.next(title);
  }

  public setSubtitle(subtitle: string = null) {
    const view = this.store.selectSnapshot(ViewState.view);
    const dateSelection = view.dateSelection;
    let date = '';
    if (dateSelection)
      if (dateSelection.rangeSelection) {
        date +=
          'från: ' +
          (dateSelection.type
            ? this.formatDate(dateSelection.from, dateSelection.type)
            : dateSelection.from);
        date +=
          ', till: ' +
          (dateSelection.type
            ? this.formatDate(dateSelection.to, dateSelection.type)
            : dateSelection.to);
      } else
        date += dateSelection.type
          ? this.formatDate(dateSelection.to, dateSelection.type)
          : dateSelection.to;

    const filterSelection = view.filterSelection;
    const filter = [];
    if (filterSelection)
      if (filterSelection.attribute)
        filter.push(filterSelection.attribute + ': ' + filterSelection.value);
      else
        Object.keys(filterSelection).map(k => {
          const f = filterSelection[k];
          filter.push(
            f.filterName +
              ': ' +
              (f.selection.length > 1 ? f.selection.join(', ') : f.selection[0])
          );
        });

    const tabs = this.store.selectSnapshot(ViewState.view).tabs.tabList;
    const selection = this.store.selectSnapshot(ViewState.view).tabs.selected;
    let tabName;
    if (tabs !== undefined && selection !== undefined)
      tabName = tabs[selection];
    this.subtitle.next([tabName, subtitle, date].concat(filter));
  }

  public setShowLocation(show: boolean) {
    this.showLocation.next(show);
  }

  formatDate(date: string, type: string) {
    switch (type) {
      case 'year':
        return moment(date).format('YYYY');
      case 'month':
        return moment(date).format('MMM-YYYY');
      case 'week':
        return 'Vecka ' + moment(date).format('W');
      case 'day':
      default:
        return moment(date).format('YYYY-MM-DD');
    }
  }
}
